import { Component, Prop, h, State, Element } from '@stencil/core';

@Component({
  tag: 'dda-sticky-footer',
  styleUrls: ['dda-sticky-footer.css'],
  shadow: false,
})
export class DdaStickyFooter {
  @Element() el: HTMLElement;

  @Prop() colorTheme?: string = 'light';
  @Prop() happinessIconHref?: string;
  @Prop() happinessIconId?: string;
  @Prop() happinessIconSrc: string;
  @Prop() happinessIconSrcDark: string;
  @Prop() happinessIconAlt: string;
  @Prop() happinessIconTooltip: string;

  @Prop() accessibilityIconHref: string;
  @Prop() accessibilityIconId: string;
  @Prop() accessibilityIconSrc: string;
  @Prop() accessibilityIconSrcDark: string;
  @Prop() accessibilityIconAlt: string;
  @Prop() accessibilityIconTooltip: string;

  @Prop() servicesIconHref: string;
  @Prop() servicesIconId: string;
  @Prop() servicesIconSrc: string;
  @Prop() servicesIconSrcDark: string;
  @Prop() servicesIconAlt: string;
  @Prop() servicesIconTooltip: string;
  @Prop() servicesIconText: string;

  @Prop() hideMiddleSection: boolean = false;
  @Prop() middleLink: string;
  @Prop() rightLink: string;

  @Prop() aiIconHref: string;
  @Prop() aiIconId: string;
  @Prop() aiIconSrc: string;
  @Prop() aiIconSrcDark: string;
  @Prop() aiIconAlt: string;
  @Prop() aiIconTooltip: string;

  @Prop() dubaiaeIconHref: string;
  @Prop() dubaiaeIconId: string;
  @Prop() dubaiaeIconSrc: string;
  @Prop() dubaiaeIconSrcDark: string;
  @Prop() dubaiaeIconSmallSrc: string;
  @Prop() dubaiaeIconAlt: string;
  @Prop() dubaiaeIconTooltip: string;

  @Prop() chatIconHref: string;
  @Prop() chatIconId: string;
  @Prop() chatIconSrc: string;
  @Prop() chatIconSrcDark: string;
  @Prop() chatIconAlt: string;
  @Prop() chatIconTooltip: string;

  @Prop() moreIconFamily: string;
  @Prop() moreIcon: string;

  @State() isHidden: boolean = false;
  private lastScrollY: number = 0;

  componentWillLoad() {
    this.handleScroll = this.handleScroll.bind(this);
  }

  componentDidLoad() {
    window.addEventListener('scroll', this.handleScroll);
  }

  private toggleFooterIcons = () => {
    const iconList = this.el.querySelector('.foot-right_links') as HTMLElement;
    const items = iconList?.querySelectorAll('li') || [];

    if (iconList) {
      const isShown = iconList.classList.contains('show-dda-icon');

      if (!isShown) {
        iconList.classList.add('show-dda-icon');
        items.forEach((item, index) => {
          (item as HTMLElement).style.transitionDelay = `${index * 100}ms`;
        });
      } else {
        items.forEach(item => {
          (item as HTMLElement).style.transitionDelay = '0ms';
        });
        iconList.classList.remove('show-dda-icon');
      }
    }
  };

  disconnectedCallback() {
    window.removeEventListener('scroll', this.handleScroll);
  }

  handleScroll() {
    const currentScrollY = window.scrollY;
    this.isHidden = currentScrollY > this.lastScrollY;
    this.lastScrollY = currentScrollY;
  }

  private parseJsonArray(jsonString: string) {
    try {
      return JSON.parse(jsonString);
    } catch (e) {
      console.error('Failed to parse JSON:', e);
      return [];
    }
  }

  happinessIconClick() {
    console.log('happoness icon click');
  }

  accessibilityIconClick() {
    console.log('Suggestion icon click');
  }

  servicesIconClick() {
    console.log('Services icon click');
  }

  chatIconClick() {
    console.log('chat icon click');
  }

  aiIconClick() {
    console.log('ai icon click');
  }

  dubaiAEClick() {
    console.log('dubai.ae icon click');
  }

  middleItemClick(item) {
    console.log('middle link item clicked:', item);
  }

  rightItemClick(item) {
    console.log('right link item clicked:', item);
  }

  render() {
    const footmiddlesection = this.parseJsonArray(this.middleLink);
    const footrightsection = this.parseJsonArray(this.rightLink);

    return (
      <div class={{ 'dda-footer': true, 'hidden': this.isHidden }}>
        <div class="footer-content">
          <div class="dda-footer-item dda-footer-left">
            <ul>
              {this.happinessIconSrc && (
                <li class="foot-icon-btn">
                  <dda-tooltip title_text={this.happinessIconTooltip} description="" position="top">
                    <a href={this.happinessIconHref} id={this.happinessIconId} onClick={this.happinessIconClick}>
                      <img src={this.colorTheme == 'light' ? this.happinessIconSrc : this.happinessIconSrcDark} alt={this.happinessIconAlt} />
                      <span class="visually-hidden">{this.happinessIconTooltip}</span>
                    </a>
                  </dda-tooltip>
                </li>
              )}

              {this.accessibilityIconSrc && (
                <li class="foot-icon-btn">
                  <dda-tooltip title_text={this.accessibilityIconTooltip} description="" position="top">
                    <a href={this.accessibilityIconHref} id={this.accessibilityIconId} onClick={this.accessibilityIconClick}>
                      <img src={this.colorTheme == 'light' ? this.accessibilityIconSrc : this.accessibilityIconSrcDark} alt={this.accessibilityIconAlt} />
                      <span class="visually-hidden">{this.accessibilityIconTooltip}</span>
                    </a>
                  </dda-tooltip>
                </li>
              )}

              {this.servicesIconText && (
                <li class="foot-icon-btn">
                  <dda-tooltip title_text={this.servicesIconTooltip} description="" position="top">
                    <a href={this.servicesIconHref} id={this.servicesIconId} onClick={this.servicesIconClick}>
                      <img src={this.colorTheme == 'light' ? this.servicesIconSrc : this.servicesIconSrcDark} alt={this.servicesIconAlt} />
                      <span>{this.servicesIconText}</span>
                    </a>
                  </dda-tooltip>
                </li>
              )}
            </ul>
          </div>

          {!this.hideMiddleSection && (
            <div class="dda-footer-item dda-footer-middle">
              <ul class="foot-logo">
                {footmiddlesection.map((middleItem, index) => (
                  <li key={index}>
                    <dda-tooltip title_text={middleItem.LogoTooltip} description="" position="top">
                      <a href={middleItem.href} onClick={() => this.middleItemClick(middleItem)}>
                        <img src={this.colorTheme == 'light' ? middleItem.src : middleItem.srcDark} alt={middleItem.alt} />
                        <span class="visually-hidden">{middleItem.LogoTooltip}</span>
                      </a>
                    </dda-tooltip>
                  </li>
                ))}
              </ul>
            </div>
          )}

          <div class="dda-footer-item dda-footer-right">
            <ul class="foot-right_links">
              {footrightsection.map((rightItem, index) => (
                <li class="foot-icon-btn" key={index}>
                  <dda-tooltip title_text={rightItem.RightLinkTooltip} description="" position="top">
                    <a
                      href={rightItem.href}
                      title={rightItem.title}
                      aria-label={`${rightItem.IconName} ${rightItem.LinkText}`}
                      id={rightItem.itemId}
                      onClick={() => this.rightItemClick(rightItem)}
                    >
                      <i class={rightItem.IconFamily}>{rightItem.IconName}</i>
                      <span>{rightItem.LinkText}</span>
                    </a>
                  </dda-tooltip>
                </li>
              ))}

              {this.dubaiaeIconSrc && this.dubaiaeIconSmallSrc && (
                <li class="foot-icon-btn">
                  <dda-tooltip title_text={this.dubaiaeIconTooltip} description="" position="top">
                    <a href={this.dubaiaeIconHref} onClick={this.dubaiAEClick} id={this.dubaiaeIconId}>
                      <img class="dubaiae-text-icon" src={this.colorTheme == 'light' ? this.dubaiaeIconSrc : this.dubaiaeIconSrcDark} alt={`${this.dubaiaeIconAlt} icon desktop`} />
                      <img class="dubaiae-small-icon" src={this.dubaiaeIconSmallSrc} alt={`${this.dubaiaeIconAlt} icon mobile`} />
                      <span class="visually-hidden">{this.dubaiaeIconTooltip}</span>
                    </a>
                  </dda-tooltip>
                </li>
              )}

              {this.aiIconSrc && (
                <li class="foot-icon-btn">
                  <dda-tooltip title_text={this.aiIconTooltip} description="" position="top">
                    <a href={this.aiIconHref} onClick={this.aiIconClick} id={this.aiIconId}>
                      <img src={this.colorTheme == 'light' ? this.aiIconSrc : this.aiIconSrcDark} alt={this.aiIconAlt} />
                      <span class="visually-hidden">{this.aiIconTooltip}</span>
                    </a>
                  </dda-tooltip>
                </li>
              )}

              {this.chatIconSrc && (
                <li class="foot-icon-btn">
                  <dda-tooltip title_text={this.chatIconTooltip} description="" position="top">
                    <a href={this.chatIconHref} onClick={this.chatIconClick} id={this.chatIconId}>
                      <img src={this.colorTheme == 'light' ? this.chatIconSrc : this.chatIconSrcDark} alt={this.chatIconAlt} />
                      <span class="visually-hidden">{this.chatIconTooltip}</span>
                    </a>
                  </dda-tooltip>
                </li>
              )}
            </ul>
            <button type="button" class="show-right-icon" onClick={this.toggleFooterIcons}>
              <i class={this.moreIconFamily}>{this.moreIcon}</i>
            </button>
          </div>
        </div>
      </div>
    );
  }
}
